import React from "react";

function TradeSummary(props) {
  const { data, seg, selection, totalValues } = props;
  // console.log(data, "datagergregrt");

  console.log(data, "dataParty");
  

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper tradeSummar-Wrapper">
        <table className="table last-column">
          <thead>
            {selection === "date" && (
              <tr className="">
                <th scope="col">Party Code</th>
                <th scope="col">DATE</th>
                <th scope="col">TYPE</th>
                <th scope="col">Symbol</th>
                {seg === "fo" && <th>Expiry Date</th>}
                {seg === "stocks" && <th scope="col">ISIN</th>}
                {/* <th scope="col">Exchange</th> */}
                <th scope="col">Quantity</th>
                <th scope="col">Price</th>
                <th scope="col">Trade Value</th>
                {seg === "curfo" && <th scope="col">Action</th>}
                {seg === "curfo" && <th scope="col">Lot Size</th>}
                {/* {seg === "stocks" && <th scope="col">Remark</th>} */}
                {/* {seg === "stocks" && <th scope="col">Flag</th>} */}
              </tr>
            )}
            {selection === "script" && (
              <>
                <tr className="for-trade1">
                  <th colSpan={1}>scrip</th>
                  {seg === "fo" && <th colSpan={1}>Expiry Date</th>}
                  <th scope="col" className="" colSpan={3}>
                    BUY
                  </th>
                  <th scope="col" className="" colSpan={3}>
                    SELL
                  </th>
                  <th scope="col" className="" colSpan={2}>
                    NET
                  </th>
                </tr>
                <tr className="for-trade2">
                  <th scope="col"></th>
                  {seg === "fo" && <th scope="col"></th>}
                  <th scope="col">QTY</th>
                  <th scope="col">Value</th>
                  <th scope="col">Avg</th>
                  <th scope="col">QTY</th>
                  <th scope="col">Value</th>
                  <th scope="col">Avg</th>
                  <th scope="col">QTY</th>
                  <th scope="col">Value</th>
                </tr>
              </>
            )}
          </thead>

          <tbody>
            {data &&
              data.map((item, key) => {
                return (
                  <>
                    {selection === "date" && (
                      <tr key={key}>
                        <td>{item?.partyCode || "-"}</td>
                        <td>{item?.date || "-"}</td>
                        <td>{item?.type || "-"}</td>
                        <td>
                          {`${item?.symbol || "-"}`}
                        </td>
                        {/* <td>
                          {`${item?.symbol || "-"} (${item?.action || "-"})`}
                        </td> */}
                        {seg === "fo" && <td>{item?.expiryDate || "-"}</td>}
                        {seg === "stocks" && <td>{item?.isin || "-"}</td>}
                        {/* <td>{item?.exchange || "-"}</td> */}
                        <td>{item?.quantity || 0}</td>
                        <td>{item?.Price || 0}</td>
                        <td>{item?.tradeValue || 0}</td>
                        {seg === "curfo" && <td>{item?.action || 0}</td>}
                        {seg === "curfo" && <td>{item?.lotSize || 0}</td>}
                        {/* {seg === "stocks" && <td>{item?.remark || 0}</td>} */}
                        {/* {seg === "stocks" && <td>{item?.flag || 0}</td>} */}
                        {/* <td>{}</td> */}
                      </tr>
                    )}
                    {selection === "script" && (
                      <tr key={key} className="for-script2">
                        <td>{item?.scrip || "-"}</td>
                        {seg === "fo" && <td>{item?.expiryDate || "-"}</td>}
                        <td>{item?.buyQty || 0}</td>
                        <td>{item?.buyValue || 0}</td>
                        <td>{item?.buyAvg || 0}</td>
                        <td>{item?.sellQty || 0}</td>
                        <td>{item?.sellValue || 0}</td>
                        <td>{item?.sellAvg || 0}</td>
                        <td>{item?.netQty || 0}</td>
                        <td>{item?.netValue || 0}</td>
                      </tr>
                    )}
                  </>
                );
              })}
          </tbody>
          {selection === "script" && (
            <tbody className="tradeSummary-table-body-total">
              <tr>
                {seg === "fo" ? <td colSpan={2}>Total</td> : <td>Total</td>}
                <td colSpan={3}>{totalValues.totaBuylValue}</td>
                <td colSpan={3}>{totalValues.totalSellValue}</td>
                <td colSpan={2}>{totalValues.totalNetValue}</td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </>
  );
}
export default TradeSummary;
